import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MarketId } from '../model/common';
import { Deal } from '../model/trade';

@Injectable({
  providedIn: 'root'
})
export class YandexMetricService {

  private counterId = environment.ymCounterId

  params<T extends Record<string, unknown>>(params?: T) {
    if (window.ym && this.counterId) window.ym(this.counterId, 'params', params)
  }

  reachGoal(goal: string, params?: Record<string, any>) {
    if (window.ym && this.counterId) window.ym(this.counterId, 'reachGoal', goal, params)
  }

  reachActiveUser() {
    this.reachGoal('active-user-terminal')
  }

  reachChangeKey() {
    this.reachGoal('terminal-change-key')
  }

  reachInteractionFeed() {
    this.reachGoal('terminal-change-feed')
  }

  reachInteractionOrders() {
    this.reachGoal('terminal-change-orders')
  }

  reachInteractionPositions() {
    this.reachGoal('terminal-change-positions')
  }

  reachInteractionSymbols() {
    this.reachGoal('terminal-change-symbols')
  }

  reachExchangeTrans(market: MarketId) {
    this.reachGoal('terminal-exchange-trans')
    switch (market) {
      case 'binance':
        this.reachGoal('terminal-exchange-trans-binance')
        break
      case 'bybit':
        this.reachGoal('terminal-exchange-trans-bybit')
        break
      case 'okx':
        this.reachGoal('terminal-exchange-trans-okx')
        break
      default: throw new Error(`Unknown market ${market}`)
    }
  }

  reachCreateOrder(orderType: 'limit-open' | 'limit-close' | 'stop') {
    switch (orderType) {
      case 'limit-open':
        this.reachGoal('terminal-create-order-limit-open')
        break
      case 'limit-close':
        this.reachGoal('terminal-create-order-limit-close')
        break
      case 'stop':
        this.reachGoal('terminal-create-order-stop')
        break
    }
  }

  reachCancelOrder() {
    this.reachGoal('terminal-cancel-order')
  }

  reachCancelOrdersHotkey() {
    this.reachGoal('terminal-cancel-orders-hotkey')
  }

  reachSelectChartObject() {
    this.reachGoal('terminal-select-chart-object')
  }

  registerDeal(deal: Deal) {
    window.dataLayer?.push(this.generateEcommerceData(deal, 408884286))

    switch (deal.market) {
      case 'binance':
        window.dataLayer?.push(this.generateEcommerceData(deal, 428689686))
        break
      case 'bybit':
        window.dataLayer?.push(this.generateEcommerceData(deal, 428690018))
        break
      case 'okx':
        window.dataLayer?.push(this.generateEcommerceData(deal, 460807618))
        break
    }
  }

  private generateEcommerceData(deal: Deal, goalId: number) {
    return {
      ecommerce: {
        currencyCode: 'USD',
        purchase: {
          actionField:  {
            id: deal.dealId,
            revenue: deal.volume,
            goal_id: goalId,
          },
          products: [{
            id: [deal.market, deal.board, deal.symbol].join(','),
            name: deal.symbol,
            brand: deal.market,
            category: deal.board,
            price: deal.price,
            quantity: deal.quantity,
          }]
        }
      }
    }
  }

  reachAiModelChange(model: string) {
    this.reachGoal('terminal-ai-interaction', {model})
  }

  reachAiMarketChange(market: MarketId) {
    this.reachGoal('terminal-ai-interaction', {market})
  }

  reachAiSymbolClick(fromBlockName: 'screener' | 'ai') {
    this.reachGoal('terminal-ai-interaction', {symbol: `${fromBlockName}_block`})
  }

}
